import {availabilitySearch, getLocations} from "../services/api";

export const SET_AVAILABILITY_PRODUCTS = 'SET_AVAILABILITY_PRODUCTS';
export const SET_SEARCH_START = 'SET_SEARCH_START';
export const SET_SEARCH_FINISH = 'SET_SEARCH_FINISH';
export const SET_SEARCH_LOADING = 'SET_SEARCH_LOADING';
export const SET_SEARCH_META = 'SET_SEARCH_META';
export const SET_SEARCH_LOCATIONS = 'SET_SEARCH_LOCATIONS';
export const SET_SELECTED_LOCATION = 'SET_SELECTED_LOCATION';
export const SET_SEARCH_LOCATIONS_LOADING = 'SET_SEARCH_LOCATIONS_LOADING';

export const onSetAvailabilityProducts = (products) => ({
  type: SET_AVAILABILITY_PRODUCTS,
  products,
});

export const onSetSearchStart = (start) => ({
  type: SET_SEARCH_START,
  start,
});

export const onSetSearchFinish = (finish) => ({
  type: SET_SEARCH_FINISH,
  finish,
});

export const onSetSearchLoading = (loading) => ({
  type: SET_SEARCH_LOADING,
  loading,
});

export const onSetSearchMeta = (meta) => ({
  type: SET_SEARCH_META,
  meta,
});

export const setSelectedLocation = (location) => ({
  type: SET_SELECTED_LOCATION,
  location,
})

export const setSearchLocations = (locations) => ({
  type: SET_SEARCH_LOCATIONS,
  locations,
})

export const onSetLocationLoading = (loading) => ({
  type: SET_SEARCH_LOCATIONS_LOADING,
  loading,
})

export const fetchLocations = (params) => (dispatch) => {
  return new Promise((resolve, reject) => {
    dispatch(onSetLocationLoading(true));
    getLocations(params).then((data) => {
      dispatch(onSetLocationLoading(false));
      dispatch(setSearchLocations(data.locations));
      resolve(data);
    }).catch((error) => {
      dispatch(onSetLocationLoading(false));
      reject(error);
    });
  });
}

export const fetchAvailabilityProducts = (params, callback) => (dispatch) => {
  return new Promise((resolve, reject) => {
    dispatch(onSetSearchLoading(true));
    availabilitySearch(params).then((data) => {
      dispatch(onSetAvailabilityProducts(data.products));
      dispatch(onSetSearchMeta(data.meta));
      dispatch(onSetSearchLoading(false));
      if (callback) callback(data)
      resolve(data);
    }).catch((error) => {
      dispatch(onSetSearchLoading(false));
      reject(error);
    });
  });
};